export function obterListaTipoOperacaoGovernamental() {
  return (
    [
      { label: '', value: null },
      { label: '1 Fornecimento', value: 'FORNECIMENTO' },
      { label: '2 Recebimento pagamento', value: 'RECEBIMENTOPAGAMENTO' },
    ]
  );
}
